export default __webpack_public_path__ + "static/2cce1cb67c6c1014efc0b1de8768791c.png";